import JSONAPISerializer from '@ember-data/serializer/json-api';
import { DateTime } from 'scaleflow/utils/date-time';

export default class TargetSerializer extends JSONAPISerializer {
  keyForAttribute(attr) {
    return attr;
  }
  normalize(typeHash, hash) {
    if (hash?.attributes?.end_date) {
      hash.attributes.end_date = DateTime.from(hash.attributes.end_date).format(
        'YYYY-MM-DD',
      );
    }
    return super.normalize(typeHash, hash);
  }
}
